var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#434242",
    height: "426.66667pt",
    viewBox: "0 0 426.66667 426.66667",
    width: "426.66667pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m213.332031 0c-117.820312 0-213.332031 95.511719-213.332031 213.332031 0 117.820313 95.511719 213.335938 213.332031 213.335938 117.820313 0 213.335938-95.515625 213.335938-213.335938-.132813-117.765625-95.566407-213.199219-213.335938-213.332031zm0 405.332031c-106.039062 0-192-85.960937-192-192 0-106.039062 85.960938-192 192-192 106.039063 0 192 85.960938 192 192-.121093 105.988281-86.011719 191.878907-192 192zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m188.355469 130.636719c-4.4375-3.878907-11.175781-3.425781-15.054688 1.007812-3.875 4.4375-3.421875 11.175781 1.011719 15.054688l76.15625 66.632812-76.160156 66.636719c-4.4375 3.878906-4.886719 10.617188-1.011719 15.050781 3.878906 4.4375 10.617187 4.890625 15.054687 1.011719l85.332032-74.667969c2.316406-2.023437 3.644531-4.953125 3.644531-8.03125s-1.328125-6.003906-3.644531-8.03125zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.60477121e88c4cc764b9833bbfc68926.svg";
export { ForwardRef as ReactComponent };